var _path, _path2, _mask, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 10C0.9 9.39249 1.39249 8.9 2 8.9H22C22.6075 8.9 23.1 9.39249 23.1 10V31C23.1 31.6075 22.6075 32.1 22 32.1H2C1.39249 32.1 0.9 31.6075 0.9 31V10Z",
    stroke: "white",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.782 22.874C15.5331 22.1468 16.0001 21.1278 16.0001 19.9998C16.0001 17.7908 14.2093 16 12.0003 16C9.79126 16 8.00049 17.7908 8.00049 19.9998C8.00049 21.128 8.46755 22.147 9.21885 22.8742C9.07811 23.2217 9.0006 23.6016 9.0006 23.9996C9.0006 25.6564 10.3437 26.9995 12.0005 26.9995C13.6572 26.9995 15.0003 25.6564 15.0003 23.9996C15.0003 23.6015 14.9228 23.2215 14.782 22.874Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.782 22.874L13.53 21.5807C13.003 22.0909 12.8382 22.8699 13.1136 23.5498L14.782 22.874ZM9.21885 22.8742L10.8872 23.5499C11.1626 22.8699 10.9978 22.0909 10.4707 21.5808L9.21885 22.8742ZM14.2001 19.9998C14.2001 20.6205 13.9454 21.1786 13.53 21.5807L16.0339 24.1673C17.1209 23.1151 17.8001 21.6352 17.8001 19.9998H14.2001ZM12.0003 17.8C13.2152 17.8 14.2001 18.7849 14.2001 19.9998H17.8001C17.8001 16.7967 15.2034 14.2 12.0003 14.2V17.8ZM9.80049 19.9998C9.80049 18.7849 10.7854 17.8 12.0003 17.8V14.2C8.79715 14.2 6.20049 16.7967 6.20049 19.9998H9.80049ZM10.4707 21.5808C10.0553 21.1787 9.80049 20.6206 9.80049 19.9998H6.20049C6.20049 21.6354 6.87985 23.1154 7.96701 24.1676L10.4707 21.5808ZM10.8006 23.9996C10.8006 23.8371 10.8319 23.6864 10.8872 23.5499L7.55048 22.1985C7.32428 22.757 7.2006 23.3661 7.2006 23.9996H10.8006ZM12.0005 25.1995C11.3378 25.1995 10.8006 24.6623 10.8006 23.9996H7.2006C7.2006 26.6505 9.34957 28.7995 12.0005 28.7995V25.1995ZM13.2003 23.9996C13.2003 24.6623 12.6631 25.1995 12.0005 25.1995V28.7995C14.6513 28.7995 16.8003 26.6505 16.8003 23.9996H13.2003ZM13.1136 23.5498C13.169 23.6863 13.2003 23.8371 13.2003 23.9996H16.8003C16.8003 23.366 16.6766 22.7568 16.4503 22.1981L13.1136 23.5498Z",
    fill: "white",
    mask: "url(#path-3-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.94b45d97.svg";
export { ForwardRef as ReactComponent };